import RoomDetail from "@/components/RoomDetail";

const FamilyRoom = () => {
  return <RoomDetail roomType="family" />;
};

export default FamilyRoom;